// src/hooks/useEscapeExitsCompare.js
//
// Esc leaves Explore's compare view (DB's answer 8, S-e slice 4b). Listened
// for only while compare is on. Not while typing in a field (Esc there belongs
// to the field), and not when something else took the key: a tool or a
// flyout that closes on Esc calls preventDefault (CommandRail's measure and
// fly-to, CountyDetailFlyout), so one Esc closes the open thing and the next
// leaves compare.
//
// DECIDED AFTER THE EVENT, not in it. Those listeners are on window and
// document too, and which runs first depends on which was added first (a
// measure started after compare was entered runs after this). By a
// microtask every listener has run, and preventDefault is final.
import { useEffect, useRef } from "react";

function typing(target) {
  if (!target || target.nodeType !== 1) return false;
  if (/^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName)) return true;
  return Boolean(target.isContentEditable || target.closest?.('[contenteditable]:not([contenteditable="false"])'));
}

/**
 * @param {boolean} enabled  compare is on
 * @param {() => void} exit  leave compare
 */
export function useEscapeExitsCompare(enabled, exit) {
  const exitRef = useRef(exit);
  useEffect(() => { exitRef.current = exit; });

  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const onKey = (e) => {
      if (e.key !== "Escape" || typing(e.target)) return;
      queueMicrotask(() => {
        if (live && !e.defaultPrevented) exitRef.current?.();
      });
    };
    window.addEventListener("keydown", onKey);
    return () => { live = false; window.removeEventListener("keydown", onKey); };
  }, [enabled]);
}
